var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestWebhook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_647_23769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 6.70016L6.56488 16.8035C6.34382 17.0246 6.08138 17.2 5.79253 17.3197C5.50368 17.4394 5.19409 17.501 4.88143 17.501C4.24998 17.5011 3.64436 17.2504 3.1978 16.8039C2.75124 16.3575 2.50032 15.7519 2.50024 15.1205C2.50017 14.489 2.75093 13.8834 3.19738 13.4368L13.299 3.3335",
    stroke: "#464D6D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83325 10.8335H12.4999",
    stroke: "#464D6D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 12.5L17.0834 13.8333C17.2956 14.0739 17.4338 14.3706 17.4815 14.6877C17.5293 15.0049 17.4844 15.3291 17.3525 15.6215C17.2205 15.9138 17.007 16.1619 16.7375 16.3358C16.4681 16.5098 16.1542 16.6024 15.8334 16.6024C15.5127 16.6024 15.1987 16.5098 14.9293 16.3358C14.6598 16.1619 14.4463 15.9138 14.3144 15.6215C14.1824 15.3291 14.1376 15.0049 14.1853 14.6877C14.233 14.3706 14.3713 14.0739 14.5834 13.8333L15.8334 12.5Z",
    stroke: "#464D6D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.5L17.5 7.5",
    stroke: "#464D6D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_647_23769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestWebhook);
export default __webpack_public_path__ + "static/media/test-webhook.46ebcbcf.svg";
export { ForwardRef as ReactComponent };